<template>
    <i
        class="icon-wrapper"
        @click="itemClick"
        @mouseover="mouseOverHandler"
        @mouseout="mouseOutHandler"
        :style="{ width: iconWidth, height: iconHeight, background: iconBg, 'background-position': iconBgPosition }"
    ></i>
</template>

<script>
export default {
    name: "Icon",
    props: ["width", "height", "iconUrl", "hoverUrl", "bgPosition", "hoverBgPosition"],
    data() {
        return {
            isMouseOn: false
        };
    },
    computed: {
        iconWidth() {
            return this.width ? this.width + "px" : "";
        },
        iconHeight() {
            return this.height ? this.height + "px" : "";
        },
        iconBg() {
            return this.url2Icon(this.hoverUrl && this.isMouseOn ? this.hoverUrl : this.iconUrl);
        },
        iconBgPosition() {
            return this.hoverBgPosition && this.isMouseOn ? this.hoverBgPosition : this.bgPosition ? this.bgPosition : "";
        }
    },
    methods: {
        itemClick(event) {
            this.$emit("iconClick", event);
        },
        mouseOverHandler() {
            this.isMouseOn = true;
        },
        mouseOutHandler() {
            this.isMouseOn = false;
        },
        url2Icon(url) {
            if (!url) {
                return "";
            }

            return url.indexOf("url") != -1 ? url : "url(" + url + ")";
        }
    }
};
</script>

<style lang="less" scoped>
.icon-wrapper {
    display: inline-block;
    content: "";
    width: 18px;
    height: 18px;
    background: url("@{zhijiStaticImagePath}class-spr.png");
    cursor: pointer;
}
</style>
